// module: action-items
import { Box } from "@mui/system";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  setCreatedOnDate,
  setSelectedAssignee,
  setSelectedCategory,
  setSelectedDueDate,
  setSelectedPriority,
  setSelectedStatus,
} from "../../../../../features/actionItemsSlice";
import { useDispatch } from "react-redux";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
interface Props {
  clearSelectedActionItems: any;
}
const ActionFilterItems = ({ clearSelectedActionItems }: Props) => {
  const dispatch = useDispatch();
  const {
    actionItemsList,
    selectedCategory,
    selectedDueDate,
    selectedPriority,
    selectedAssignee,
    selectedStatus,
    createdOnDate,
  } = useSelector((state: any) => state.actionItems);
// const
  const categoryNames = actionItemsList
    .map((item: any) => {
      const categoryName = item.data["category"]; // Optional chaining
      return categoryName ? { category: categoryName } : null; // Return null if undefined
    })
    .filter((item: any) => item !== null);

  const priorityNames = actionItemsList
    .map((item: any) => {
      const priorityName = item.data["priority"]; // Optional chaining
      return priorityName ? { priority: priorityName } : null; // Return null if undefined
    })
    .filter((item: any) => item !== null);

  const [searchCategory, setSearchCategory] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchAssignee, setSearchAssignee] = useState("");
  const [searchPriority, setSearchPriority] = useState("");

  //-- Set Filter Configuaration
  const filterConfig = [
    {
      key: "category",
      label: "Select Category",
      searchTerm: searchCategory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCategory(e.target.value),
      selectedOption: selectedCategory,
      filterName: "category",
      data: categoryNames,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCategory(updatedSelection)),
      count: selectedCategory && selectedCategory.length,
      colorSelected:
        selectedCategory !== null && selectedCategory.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "status",
      label: "Select Status",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStatus(e.target.value),
      selectedOption: selectedStatus,
      filterName: "current_status",
      data: actionItemsList,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedStatus(updatedSelection)),
      count: selectedStatus && selectedStatus.length,
      colorSelected:
        selectedStatus !== null && selectedStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },

    {
      key: "priority",
      label: "Select Priority",
      searchTerm: searchPriority,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchPriority(e.target.value),
      selectedOption: selectedPriority,
      filterName: "priority",
      data: priorityNames,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedPriority(updatedSelection)),
      count: selectedPriority && selectedPriority.length,
      colorSelected:
        selectedPriority !== null && selectedPriority.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "due date",
      label: "Select Date",
      searchTerm: "",
      selectedOption: selectedDueDate,
      filterName: "due_date",
      data: actionItemsList,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDueDate(updatedSelection)),
      count: selectedDueDate && selectedDueDate.length - 1,
      colorSelected:
        selectedDueDate !== null && selectedDueDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
    {
      key: "assignee",
      label: "Select Assignee",
      searchTerm: searchAssignee,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAssignee(e.target.value),
      selectedOption: selectedAssignee,
      filterName: "assignee_fullname",
      data: actionItemsList,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAssignee(updatedSelection)),
      count: selectedAssignee && selectedAssignee.length,
      colorSelected:
        selectedAssignee !== null && selectedAssignee.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "created on",
      label: "Select Date",
      searchTerm: "",
      selectedOption: createdOnDate,
      filterName: "modified_at",
      data: actionItemsList,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setCreatedOnDate(updatedSelection)),
      count: createdOnDate && createdOnDate.length - 1,
      colorSelected:
        createdOnDate !== null && createdOnDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
  ];

  //-- Remove filters
  const clearFilters = () => {
    dispatch(setSelectedCategory(null));
    dispatch(setSelectedStatus(null));
    dispatch(setCreatedOnDate(null));
    dispatch(setSelectedAssignee(null));
    dispatch(setSelectedPriority(null));
    dispatch(setSelectedDueDate(null));
    clearSelectedActionItems(null);
    setSearchCategory("");
    setSearchStatus("");
    setSearchAssignee("");
    setSearchPriority("");
  };
  return (
    <>
      <Box data-tracker="109">
        <FilterComponent
          filterConfig={filterConfig}
          clearFilters={clearFilters}
        />
      </Box>
    </>
  );
};

export default ActionFilterItems;
